var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('asc-spinner-wrapper',{attrs:{"loading":_vm.loading}},[_c('asc-fault-monitor-detail-item',{attrs:{"item":_vm.definition}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }